var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrecisionHealthGuidance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 188,
    viewBox: "0 0 160 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2244C0 5.47306 5.47308 0 12.2245 0H116.132C122.884 0 128.357 5.47308 128.357 12.2245V145.165C128.357 151.917 122.884 157.39 116.132 157.39H12.2245C5.47307 157.39 0 151.917 0 145.165V12.2244Z",
    fill: "#D4DBE9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.2764,
    y: 28.0146,
    width: 57.5568,
    height: 6.62158,
    rx: 2.03741,
    fill: "#007580"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.2764,
    y: 50.4258,
    width: 57.5568,
    height: 6.62158,
    rx: 2.03741,
    fill: "#007580"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.2764,
    y: 72.8359,
    width: 57.5568,
    height: 6.62158,
    rx: 2.03741,
    fill: "#007580"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 17.0629,
    y: 24.7035,
    width: 13.2432,
    height: 13.2432,
    rx: 0.764029,
    fill: "#7E92BE",
    stroke: "white",
    strokeWidth: 1.52806
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 17.0629,
    y: 48.6429,
    width: 13.2432,
    height: 13.2432,
    rx: 0.764029,
    fill: "#7E92BE",
    stroke: "white",
    strokeWidth: 1.52806
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 17.0629,
    y: 69.5267,
    width: 13.2432,
    height: 13.2432,
    rx: 0.764029,
    fill: "#7E92BE",
    stroke: "white",
    strokeWidth: 1.52806
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 17.0629,
    y: 91.9379,
    width: 13.2432,
    height: 13.2432,
    rx: 0.764029,
    fill: "#7E92BE",
    stroke: "white",
    strokeWidth: 1.52806
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 42.2764,
    y: 95.25,
    width: 57.5568,
    height: 6.62158,
    rx: 2.03741,
    fill: "#007580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0977 30.2301C23.6209 29.6662 22.7772 29.5955 22.2132 30.0723C21.6493 30.5491 21.5786 31.3928 22.0554 31.9568L25.7246 36.2967C26.2014 36.8606 27.0451 36.9313 27.609 36.4545C28.173 35.9777 28.2437 35.134 27.7669 34.57L24.0977 30.2301Z",
    fill: "#284993"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7783 25.4893L34.8556 25.5665C35.8573 26.5683 35.8573 28.1924 34.8556 29.1941L27.6598 36.3899C27.1376 36.9121 26.291 36.9121 25.7688 36.3899C25.2466 35.8677 25.2466 35.021 25.7688 34.4988L34.7783 25.4893Z",
    fill: "#284993"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0977 52.6422C23.6209 52.0783 22.7772 52.0076 22.2132 52.4844C21.6493 52.9612 21.5786 53.8049 22.0554 54.3689L25.7246 58.7088C26.2014 59.2727 27.0451 59.3434 27.609 58.8666C28.173 58.3898 28.2437 57.5461 27.7669 56.9821L24.0977 52.6422Z",
    fill: "#284993"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7783 47.9014L34.8556 47.9787C35.8573 48.9804 35.8573 50.6045 34.8556 51.6062L27.6598 58.802C27.1376 59.3242 26.291 59.3242 25.7688 58.802C25.2466 58.2798 25.2466 57.4331 25.7688 56.9109L34.7783 47.9014Z",
    fill: "#284993"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.108 172.582C112.315 175.374 107.787 175.374 104.994 172.582L104.098 171.687C92.2342 159.829 92.2342 140.603 104.098 128.745L118.195 114.654C125.771 107.082 138.053 107.082 145.629 114.654C153.205 122.226 153.205 134.503 145.629 142.075L115.108 172.582Z",
    fill: "#FF7F50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.116 172.582C107.909 175.374 112.437 175.374 115.23 172.582L116.126 171.687C127.989 159.829 127.989 140.603 116.126 128.745L102.028 114.654C94.4527 107.082 82.1701 107.082 74.5945 114.654C67.0188 122.226 67.0188 134.503 74.5945 142.075L105.116 172.582Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecisionHealthGuidance);
export default __webpack_public_path__ + "static/media/PrecisionHealthGuidance.f4c2d02b3432a8bc67049858ef2e7663.svg";
export { ForwardRef as ReactComponent };